import type { RedoSupportRpcClient } from "@redotech/redo-merchant-support-rpc/client";
import { createRedoSupportRpcClient } from "@redotech/redo-merchant-support-rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoSupportAuthRpcClientContext: Context<
  RedoSupportRpcClient | undefined
> = createContext<RedoSupportRpcClient | undefined>(undefined);

RedoSupportAuthRpcClientContext.displayName = "RedoSupportAuthRpcClientContext";

export interface RedoSupportRpcClientProviderProps {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}

export function RedoSupportRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: RedoSupportRpcClientProviderProps) {
  const authClient = useMemo(() => {
    if (!authToken) {
      return undefined;
    }
    return createRedoSupportRpcClient({
      baseURL: new URL(`${baseUrl}/support-rpc`),
      headers: { Authorization: authToken },
    });
  }, [baseUrl, authToken]);

  return (
    <RedoSupportAuthRpcClientContext.Provider value={authClient}>
      {children}
    </RedoSupportAuthRpcClientContext.Provider>
  );
}
